import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDriverLicenseStart = loadable(
  () => import('./DriverLicenseStart'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableDriverLicenseStart;
